import $ from "jquery";

const savedSearchSelectChanged = function () {
  $(this).closest("form").submit();
};

$(document).on("turbolinks:load", function () {
  $("#saved_search_search_id").on("change", savedSearchSelectChanged);
});
